<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Occupation" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-occupation-form [occupation]="occupation" *ngIf="occupation"></app-occupation-form>
        </form>
      </div>
    </section>
  </div>
</div>


